"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import $ from "jquery";
import _ from "underscore";
import ApiService from "../services/api_service";
import Auth from "../util/auth";
class AlertArea extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "showAlert", (event, errorObject) => {
      this.setState({
        alertShowing: true,
        alertMessage: errorObject.message,
        alertDetails: errorObject.details ? _.extend(errorObject.details, { location: window.location }) : null,
        alertType: errorObject.type === void 0 ? "alert" : errorObject.type
      });
    });
    __publicField(this, "closeAlert", () => {
      this.setState({ alertShowing: false });
    });
    __publicField(this, "viewDetails", () => {
      this.setState(__spreadProps(__spreadValues({}, this.state), { viewingDetails: true }));
    });
    this.state = {
      alertShowing: false
    };
  }
  componentDidMount() {
    $(ApiService).on("ApiService:alertError", this.showAlert);
  }
  componentWillUnmount() {
    $(ApiService).off("ApiService:alertError", this.showAlert);
  }
  errorText() {
    return "Please describe what you were doing above this line.\n----------------------------------\n\n" + btoa(JSON.stringify(this.state.alertDetails));
  }
  details() {
    if (this.state.viewingDetails) {
      const supportEmail = Auth._currentUser.account.settings.processor_support_email_address;
      const supportMessage = supportEmail ? "an email to" : "a support ticket at";
      const supportUrl = supportEmail ? `mailto:${supportEmail}` : "https://paymentshelp.triumph.io/support/tickets/new";
      const target = supportEmail ? void 0 : "_blank";
      const supportText = supportEmail ? supportEmail : "TriumphPay Support";
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box__error-details" }, /* @__PURE__ */ React.createElement("h3", null, "Error Details"), /* @__PURE__ */ React.createElement("p", null, "Copy and paste this information into ", supportMessage, " ", /* @__PURE__ */ React.createElement("a", { href: supportUrl, target }, supportText), ":"), /* @__PURE__ */ React.createElement("textarea", { value: this.errorText(), rows: 12 }));
    }
  }
  notifySupportLink() {
    if (!this.state.viewingDetails && !_.isEmpty(this.state.alertDetails)) {
      return /* @__PURE__ */ React.createElement("a", { className: "alert-box__support-link", onClick: this.viewDetails }, "View Details.");
    }
  }
  alertBox() {
    if (this.state.alertShowing) {
      return /* @__PURE__ */ React.createElement("div", { className: "app-alert-area alert-row row" }, /* @__PURE__ */ React.createElement("div", { className: "alert-box " + this.state.alertType + " radius" }, this.state.alertMessage, "\xA0", this.notifySupportLink(), this.details(), /* @__PURE__ */ React.createElement("a", { onClick: this.closeAlert, className: "close" }, /* @__PURE__ */ React.createElement("span", { className: "app-alert-area__close-text" }, "\xD7"))));
    }
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { id: "alert-area", "data-component": "AlertArea" }, this.alertBox());
  }
}
export default AlertArea;
